import clsx from 'clsx'

import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

type Props = {
  title: string
  description: string
  onClick?: () => void
}
export const MplusPopup = ({ title, description, onClick }: Props) => {
  const { closeDialog } = useDialogBottomSheet()
  return (
    <div className={s.mplusPopup}>
      <div className={s.text}>
        <h4 className={clsx(s.title, 'bold-20')}>{title}</h4>
        <p className={clsx(s.description, 'regular-14')}>{description}</p>
      </div>

      <Button onClick={onClick || closeDialog}>
        <span className={clsx(s.button, 'semi-bold-17')}>Ок</span>
      </Button>
    </div>
  )
}
